(() => {
  'use strict';

  const COLOR_PATTERN = /colou?r/i;
  const NAV_CLASS = 'vowhound-mobile-gallery-nav';
  const OVERLAY_CLASS = 'vowhound-mobile-gallery-overlay';
  const STYLE_ID = 'vowhound-mobile-gallery-nav-style';
  let observerTimer;

  const normalize = (value = '') =>
    String(value)
      .toLowerCase()
      .replace(/&amp;/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const padded = (value = '') => ' ' + normalize(value) + ' ';

  const mediaText = (element) => {
    const parts = [];
    element.querySelectorAll('img').forEach((img) => {
      parts.push(img.getAttribute('alt') || '');
      parts.push(img.currentSrc || '');
      parts.push(img.getAttribute('src') || '');
      parts.push(img.getAttribute('srcset') || '');
    });
    return padded(parts.join(' '));
  };

  const optionLabel = (control) => {
    if (control instanceof HTMLInputElement) {
      const fieldset = control.closest('fieldset');
      const legend = fieldset?.querySelector(':scope > legend');
      if (legend) {
        const textNode = Array.from(legend.childNodes).find((node) => node.nodeType === Node.TEXT_NODE);
        return (textNode?.textContent || legend.textContent || '').trim();
      }
      return control.name || '';
    }

    if (control instanceof HTMLSelectElement) {
      const wrapper = control.closest('.variant-option--dropdowns, .variant-option');
      const label = wrapper?.querySelector('label');
      return (label?.textContent || control.name || '').trim();
    }

    return '';
  };

  const isColorControl = (control) =>
    (control instanceof HTMLInputElement || control instanceof HTMLSelectElement) &&
    COLOR_PATTERN.test(optionLabel(control));

  const selectedColor = () => {
    const picker = document.querySelector('main variant-picker, product-information variant-picker, variant-picker');
    if (!picker) return '';

    const checked = Array.from(picker.querySelectorAll('input[type="radio"]:checked')).find(isColorControl);
    if (checked instanceof HTMLInputElement) return checked.value;

    const select = Array.from(picker.querySelectorAll('select')).find(isColorControl);
    if (select instanceof HTMLSelectElement) return select.value;

    return '';
  };

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      media-gallery[data-vowhound-missing-preview="true"] > :not(.vowhound-preview-warning) { display: none !important; }
      .vowhound-preview-warning { display: flex; box-sizing: border-box; min-height: 340px; width: 100%; padding: 32px; background: #f8f8f6; border: 1px solid #ddd; align-items: center; justify-content: center; flex-direction: column; gap: 12px; text-align: center; font-size: 15px; line-height: 1.5; }
      .vowhound-preview-warning strong { color: #111; font-size: 21px; }
      .vowhound-preview-warning span { color: #4b4b4b; max-width: 24rem; }

      .${NAV_CLASS},
      .${OVERLAY_CLASS} {
        display: none;
      }

      @media screen and (max-width: 749px) {
        media-gallery {
          position: relative;
        }

        .${NAV_CLASS} {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          width: 100%;
          padding: 10px 12px 6px;
          box-sizing: border-box;
        }

        .${NAV_CLASS}__button {
          width: 46px;
          height: 46px;
          min-width: 46px;
          border: 1px solid rgb(0 0 0 / 16%);
          border-radius: 999px;
          background: #111;
          color: #fff;
          box-shadow: 0 3px 12px rgb(0 0 0 / 16%);
          font-size: 27px;
          font-weight: 700;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .${NAV_CLASS}__button:disabled {
          opacity: 0.28;
          cursor: default;
        }

        .${NAV_CLASS}__status {
          min-width: 132px;
          text-align: center;
          color: #111;
          line-height: 1.15;
        }

        .${NAV_CLASS}__count {
          display: block;
          font-size: 15px;
          font-weight: 800;
          letter-spacing: 0.02em;
        }

        .${NAV_CLASS}__hint {
          display: block;
          margin-top: 3px;
          font-size: 12px;
          font-weight: 600;
          opacity: 0.7;
        }

        .${NAV_CLASS}__dots {
          display: flex;
          justify-content: center;
          gap: 6px;
          margin-top: 6px;
        }

        .${NAV_CLASS}__dot {
          width: 7px;
          height: 7px;
          padding: 0;
          border: 0;
          border-radius: 999px;
          background: rgb(0 0 0 / 24%);
        }

        .${NAV_CLASS}__dot[aria-current="true"] {
          background: #111;
          transform: scale(1.28);
        }

        .${OVERLAY_CLASS} {
          display: block;
          position: absolute;
          inset: 0 0 auto 0;
          height: min(78vw, 620px);
          pointer-events: none;
          z-index: 8;
        }

        .${OVERLAY_CLASS}__badge {
          position: absolute;
          top: 12px;
          right: 12px;
          padding: 8px 11px;
          border-radius: 999px;
          background: rgb(17 17 17 / 88%);
          color: #fff;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.05em;
          box-shadow: 0 2px 10px rgb(0 0 0 / 18%);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
        }

        .${OVERLAY_CLASS}__arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 48px;
          height: 48px;
          border: 0;
          border-radius: 999px;
          background: rgb(17 17 17 / 88%);
          color: #fff;
          box-shadow: 0 3px 14px rgb(0 0 0 / 22%);
          font-size: 30px;
          font-weight: 800;
          line-height: 1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          pointer-events: auto;
          cursor: pointer;
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
        }

        .${OVERLAY_CLASS}__previous {
          left: 10px;
        }

        .${OVERLAY_CLASS}__next {
          right: 10px;
        }

        .${OVERLAY_CLASS}__arrow:disabled {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const restoreMarked = (root) => {
    root.querySelectorAll('[data-vowhound-color-hidden="true"]').forEach((el) => {
      el.removeAttribute('hidden');
      el.removeAttribute('data-vowhound-color-hidden');
    });

    root.querySelectorAll('[data-vowhound-controls-hidden="true"]').forEach((el) => {
      el.style.removeProperty('display');
      el.removeAttribute('data-vowhound-controls-hidden');
    });
  };

  const setHidden = (element, shouldHide) => {
    if (!(element instanceof HTMLElement)) return;
    if (shouldHide) {
      element.removeAttribute('reveal');
      element.hidden = true;
      element.dataset.vowhoundColorHidden = 'true';
    }
  };

  const matchesColor = (element, color) => {
    const colorNeedle = padded(color);
    if (!colorNeedle.trim()) return false;
    return mediaText(element).includes(colorNeedle);
  };

  const filterGroup = (elements, color) => {
    const list = Array.from(elements).filter((el) => el instanceof HTMLElement);
    if (!list.length) return 0;

    const matches = list.filter((el) => matchesColor(el, color));
    if (!matches.length) return 0;

    list.forEach((el) => setHidden(el, !matches.includes(el)));
    return matches.length;
  };

  const visibleSlides = (slideshow) =>
    Array.from(slideshow?.querySelectorAll('slideshow-slide') || []).filter(
      (slide) => !slide.hasAttribute('hidden')
    );

  const removeMobileUi = (gallery) => {
    gallery?.querySelector('.' + NAV_CLASS)?.remove();
    gallery?.querySelector('.' + OVERLAY_CLASS)?.remove();
  };

  const updateMobileUi = (gallery, slideshow) => {
    if (!gallery || !slideshow) {
      removeMobileUi(gallery);
      return;
    }

    const slides = visibleSlides(slideshow);
    const total = slides.length;

    if (total <= 1) {
      removeMobileUi(gallery);
      return;
    }

    ensureStyles();

    let nav = gallery.querySelector('.' + NAV_CLASS);
    if (!nav) {
      nav = document.createElement('div');
      nav.className = NAV_CLASS;
      nav.setAttribute('aria-label', 'Product photo controls');
      nav.innerHTML =
        '<button type="button" class="' + NAV_CLASS + '__button ' + NAV_CLASS + '__previous" aria-label="Previous product photo">‹</button>' +
        '<div class="' + NAV_CLASS + '__status" aria-live="polite">' +
          '<span class="' + NAV_CLASS + '__count"></span>' +
          '<span class="' + NAV_CLASS + '__hint">Swipe to see every photo</span>' +
          '<span class="' + NAV_CLASS + '__dots" aria-hidden="true"></span>' +
        '</div>' +
        '<button type="button" class="' + NAV_CLASS + '__button ' + NAV_CLASS + '__next" aria-label="Next product photo">›</button>';

      slideshow.insertAdjacentElement('afterend', nav);

      nav.querySelector('.' + NAV_CLASS + '__previous')?.addEventListener('click', (event) => {
        if (typeof slideshow.previous === 'function') slideshow.previous(event, { animate: true });
      });

      nav.querySelector('.' + NAV_CLASS + '__next')?.addEventListener('click', (event) => {
        if (typeof slideshow.next === 'function') slideshow.next(event, { animate: true });
      });
    }

    let overlay = gallery.querySelector('.' + OVERLAY_CLASS);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = OVERLAY_CLASS;
      overlay.innerHTML =
        '<span class="' + OVERLAY_CLASS + '__badge"></span>' +
        '<button type="button" class="' + OVERLAY_CLASS + '__arrow ' + OVERLAY_CLASS + '__previous" aria-label="Previous product photo">‹</button>' +
        '<button type="button" class="' + OVERLAY_CLASS + '__arrow ' + OVERLAY_CLASS + '__next" aria-label="Next product photo">›</button>';

      gallery.appendChild(overlay);

      overlay.querySelector('.' + OVERLAY_CLASS + '__previous')?.addEventListener('click', (event) => {
        if (typeof slideshow.previous === 'function') slideshow.previous(event, { animate: true });
      });

      overlay.querySelector('.' + OVERLAY_CLASS + '__next')?.addEventListener('click', (event) => {
        if (typeof slideshow.next === 'function') slideshow.next(event, { animate: true });
      });
    }

    const safeCurrent = Math.max(0, Math.min(Number(slideshow.current) || 0, total - 1));

    const count = nav.querySelector('.' + NAV_CLASS + '__count');
    const prev = nav.querySelector('.' + NAV_CLASS + '__previous');
    const next = nav.querySelector('.' + NAV_CLASS + '__next');
    const dots = nav.querySelector('.' + NAV_CLASS + '__dots');

    if (count) count.textContent = (safeCurrent + 1) + ' / ' + total + ' PHOTOS';
    if (prev instanceof HTMLButtonElement) prev.disabled = safeCurrent <= 0;
    if (next instanceof HTMLButtonElement) next.disabled = safeCurrent >= total - 1;

    if (dots) {
      dots.innerHTML = '';
      for (let i = 0; i < total; i += 1) {
        const dot = document.createElement('span');
        dot.className = NAV_CLASS + '__dot';
        dot.setAttribute('aria-current', i === safeCurrent ? 'true' : 'false');
        dots.appendChild(dot);
      }
    }

    const badge = overlay.querySelector('.' + OVERLAY_CLASS + '__badge');
    const overlayPrev = overlay.querySelector('.' + OVERLAY_CLASS + '__previous');
    const overlayNext = overlay.querySelector('.' + OVERLAY_CLASS + '__next');

    if (badge) badge.textContent = total + ' PHOTOS';
    if (overlayPrev instanceof HTMLButtonElement) overlayPrev.disabled = safeCurrent <= 0;
    if (overlayNext instanceof HTMLButtonElement) overlayNext.disabled = safeCurrent >= total - 1;

    if (slideshow.dataset.vowhoundMobileNavBound !== 'true') {
      slideshow.dataset.vowhoundMobileNavBound = 'true';
      slideshow.addEventListener('slideshow:select', () => {
        window.requestAnimationFrame(() => updateMobileUi(gallery, slideshow));
      });
    }
  };

  const applyColorFilter = (requestedColor = '') => {
    const color = requestedColor || selectedColor();
    const gallery = document.querySelector('main media-gallery, product-information media-gallery, media-gallery');
    if (!gallery || !color) return;

    restoreMarked(gallery);

    // Show a warning only until the corresponding original Printful mockup
    // actually exists in the product gallery; automatically remove it on sync.
    const path = window.location.pathname.toLowerCase();
    const previewColor = path.includes('/products/vowhound-pack-rules-back-print-t-shirt') && normalize(color) === 'sapphire'
      ? 'Sapphire'
      : path.includes('/products/vowhound-goodest-dog-graphic-t-shirt') && normalize(color) === 'yellow haze'
        ? 'Yellow Haze'
        : '';
    const hasColorImage = previewColor && mediaText(gallery).includes(padded(previewColor));
    let warning = gallery.querySelector('.vowhound-preview-warning');
    if (previewColor && !hasColorImage) {
      gallery.dataset.vowhoundMissingPreview = 'true';
      if (!warning) {
        warning = document.createElement('div');
        warning.className = 'vowhound-preview-warning';
        warning.setAttribute('role', 'status');
        gallery.prepend(warning);
      }
      warning.textContent = previewColor + ' photo is being updated. You can still select and order this color.';
      removeMobileUi(gallery);
      return;
    }
    gallery.removeAttribute('data-vowhound-missing-preview');
    warning?.remove();

    let matches = 0;

    matches += filterGroup(
      gallery.querySelectorAll('.media-gallery__grid > .product-media-container, .media-gallery__grid > li'),
      color
    );

    const slideshow = gallery.querySelector('slideshow-component');
    if (slideshow) {
      matches += filterGroup(slideshow.querySelectorAll('slideshow-slide'), color);
    }

    matches += filterGroup(
      gallery.querySelectorAll('.dialog-zoomed-gallery > .product-media-container, .dialog-zoomed-gallery > li'),
      color
    );

    matches += filterGroup(
      gallery.querySelectorAll('.dialog-thumbnails-list__thumbnail'),
      color
    );

    if (matches === 0) {
      restoreMarked(gallery);
      removeMobileUi(gallery);
      return;
    }

    gallery.querySelectorAll('slideshow-controls').forEach((controls) => {
      if (!(controls instanceof HTMLElement)) return;
      controls.style.display = 'none';
      controls.dataset.vowhoundControlsHidden = 'true';
    });

    if (slideshow && typeof slideshow.select === 'function') {
      requestAnimationFrame(() => {
        try {
          slideshow.select(0, undefined, { animate: false });
        } catch (_) {}
        updateMobileUi(gallery, slideshow);
      });
    } else {
      removeMobileUi(gallery);
    }

    gallery.dataset.vowhoundSelectedColor = color;
  };

  const scheduleFilter = (color = '') => {
    applyColorFilter(color);
    window.setTimeout(() => applyColorFilter(color), 80);
    window.setTimeout(() => applyColorFilter(color), 260);
    window.setTimeout(() => applyColorFilter(color), 700);
  };

  const init = () => {
    ensureStyles();
    scheduleFilter();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!isColorControl(control)) return;

    const color =
      control instanceof HTMLInputElement || control instanceof HTMLSelectElement
        ? control.value
        : '';

    scheduleFilter(color);
  }, true);

  document.addEventListener('variant:update', () => {
    scheduleFilter();
  });

  const observeRoot = document.querySelector('main') || document.body;
  if (observeRoot) {
    const observer = new MutationObserver(() => {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => {
        const gallery = document.querySelector('main media-gallery, product-information media-gallery, media-gallery');
        const slideshow = gallery?.querySelector('slideshow-component');
        applyColorFilter();
        if (gallery && slideshow) updateMobileUi(gallery, slideshow);
      }, 60);
    });
    observer.observe(observeRoot, { childList: true, subtree: true });
  }
})();